import { useState, useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import { getOrCreateTimer, getTimeLeft, clearTimer } from "./timerStore";

const WarningBanner = ({
  closeChat,
  message,
  chatId,
  showTimer = true,
  initialMinutes = 10
}) => {

  const [timeLeft, setTimeLeft] = useState(
    () => getTimeLeft(chatId) || initialMinutes * 60
  );

  useEffect(
    () => {
      if (!showTimer) return;

      const interval = setInterval(() => {
        const left = getTimeLeft(chatId);
        setTimeLeft(left);

        if (left <= 0) {
          clearInterval(interval);
          clearTimer(chatId);
          closeChat(chatId);
        }
      }, 1000);

      return () => clearInterval(interval);
    },
    [chatId, showTimer, initialMinutes]
  );

  const formatTime = seconds => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const displayMessage =
    showTimer && message.includes("10 minutes")
      ? message.replace("10 minutes", formatTime(timeLeft))
      : message;

  return (
    <div className="mx-4 mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-2xl">
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0">
          <AlertTriangle size={20} className="text-yellow-600" />
        </div>
        <p className="text-sm text-gray-700 leading-relaxed">
          {displayMessage}
        </p>
      </div>
    </div>
  );
};

export default WarningBanner;
